<template>
    <div class="mt-5">
        <div :class="[{'border-bottom': collapsed}, 'd-flex justify-content-between align-items-end']">
            <div class="h4">
                <a href="javascript:void(0)" class="mr-2" role="button" @click="collapsed = !collapsed">
                    <i :class="['fas text-muted', collapsed ? 'fa-caret-right' : 'fa-caret-down']"></i>
                </a>
                Other Documents                
            </div>
            <div v-if="!collapsed" class="btn-toolbar" role="toolbar">
                <div class="input-group input-group-sm mr-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                    </div>
                    <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
                </div>               
                <div class="btn-group"> 
                    <button type="button" class="btn btn-primary btn-sm mb-1" data-toggle="tooltip" title="Upload File" @click="uploadDocument()">
                        <i class="fas fa-file-upload fa-lg"></i>
                    </button>
                </div>
            </div>
        </div>
        <div id="otherDocumentsTable" :class="['collapse', { 'show': !collapsed }]">
            <div v-if="isLoading" class="pt-3">            
                <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
            </div>
            <div v-else-if="filteredDocuments.length === 0" class="border-top"><h3 class="text-muted text-center mt-3">No Documents.</h3></div>             
            <table v-else class="table table-sm">
                <thead>
                    <tr>
                        <th class="fit">Document Type</th>
                        <th>Description</th>
                        <th class="fit">Owner</th>
                        <th class="fit">Uploaded/Received</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="doc in filteredDocuments">
                        <tr class="table-stripe" :key="doc.id">
                            <td class="fit pr-3">
                                <document-status-icon v-bind:document-id="doc.id" v-bind:document-status="doc.document_status"></document-status-icon>
                                <i :class="['text-muted mr-1', getIconClass(doc)]"></i>
                                <a :href="'/claims/' + claimId + '/documents/' + doc.id" target="_blank" :class="getReadClass(doc)">{{ doc.document_type.name }}</a>                            
                            </td>
                            <td>
                                <input v-if="doc.edit" class="form-control form-control-sm" v-model="doc.description" @blur="changeDescription(doc)" @keyup.enter="changeDescription(doc)" v-focus>
                                <span v-else @click="doc.edit = true;" :title="doc.description">                                
                                    {{ doc.description | truncate(80) }}
                                    <a href="javascript:void(0)" class="edit-button"><i class="fas fa-pencil-alt fa-xs"></i></a>
                                </span>
                            </td>
                            <td class="fit pr-3">{{ doc.owner }}</td>
                            <td class="fit pr-3">{{ doc.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                            <td class="fit">
                                <div class="d-flex flex-nowrap flex-row justify-content-end">

                                    <!-- delete document -->
                                    <div class="text-center">

                                        <!-- disassociate document -->
                                        <button  v-if="doc.can_disassociate" type="button" class="btn btn-link px-1" title="Unlink from Claim" @click="confirmDisassociate(doc.id)">
                                            <i class="fas fa-unlink fa-lg fa-fw"></i>
                                        </button> 

                                        <button v-else class="btn btn-link px-2" :class="{'invisible': !doc.can_delete}" title="Delete Document" @click="confirmDelete(doc.id)">
                                            <i class="fas fa-trash-alt fa-lg fa-fw"></i>
                                        </button>                                  
                                    </div>

                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { DocumentType } from '../../constants.js';
import DocumentStatusIcon from './DocumentStatusIconComponent.vue';

export default {
    components: {
        DocumentStatusIcon
    },
    props: {
        claimId: Number
    },
    data() {
        return {
            documents: [],
            searchString: '',
            collapsed: false,
            isLoading: false,
            options: [],

            // import constants into the template
            DocumentType: DocumentType      
        }
    },
    computed: {
        filteredDocuments: function () {
            const self = this;

            // filter on description
            return self.documents.filter(function (doc) {
                return (doc.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
            });
        }
    },
    methods: {
        refresh: function (reset=false) {

            // only display loading indicator when page is initially loading
            this.isLoading = reset;
            axios.get('/ajax/claims/' + this.claimId + '/other-documents')
                .then(response => {

                    this.documents = response.data.documents.map(e => { this.$set(e, 'edit', false); return e; });

                    if (reset) {
                        this.collapsed = response.data.collapsed;
                        this.options = response.data.options;
                    }
                    
                    // enable popover tooltips
                    this.$nextTick(() => {
                        $('[data-toggle="tooltip"]').tooltip();
                        $('[data-toggle="popover"]').popover();                        
                    });
                    
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                });
        },
        getIconClass: function (doc) {
            let icon = 'fas fa-file';
            switch(parseInt(doc.document_type_id)) {
                case DocumentType.INBOUND_FAX:
                    icon = doc.read_at ? 'far fa-envelope-open' : 'far fa-envelope';
                    break;
                default:
                    break;
            }
            return icon + ' fa-lg';
        },
        getReadClass: function (doc) {            
            return (doc.document_type_id == DocumentType.INBOUND_FAX && !doc.read_at) ? 'font-weight-bold' : '';
        },
        getReadContent: function (doc) {
            return 'Read by ' +  doc.read_by.full_name + ' on ' +  this.$options.filters.localizeTime(doc.read_at, 'YYYY-MM-DD HH:mm:ss');
        },
        changeDescription: function (document) {

            document.edit = false;

            // update the model
            this.$emit('update');

            // send the change to the server
            axios.patch('/ajax/documents/' + document.id + '/description', {
                'description': document.description,
            })
            .then(response => {
                // nothing to do
            })
            .catch(error => {
                // nothing to do
            });            
        },               
        uploadDocument: function () {

            // set default document type
            let selectedOption = DocumentType.OTHER;

            // show the upload file modal
            eventHub.$emit('show-file-upload', {
                claimId: this.claimId,
                url: '/ajax/claims/' + this.claimId + '/upload',
                options: this.options,
                documentType: selectedOption,
                associateToDocumentId: null
            });
        },        
        confirmDelete: function (id) {
            eventHub.$emit('show-delete-document-confirmation', id);
        },
        confirmDisassociate: function (id) {
            const url = '/ajax/responses/' + id + '/disassociate';
            const message = 'Unlinking the document will send it to the Inbox. Are you sure you want to unlink this document?'
            eventHub.$emit('show-disassociate-confirmation', url, null, message);
        },                     
    },
    created() {
        this.refresh(true);
        eventHub.$on('update-claim-documents', this.refresh);
    },
    beforeDestroy() {
        eventHub.$off('update-claim-documents');
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            }
        }
    }        
}
</script>

<style scoped>

    .table-sm td {
        padding-top: 0;
        padding-bottom: 0;
        vertical-align: middle;
    }

    .table-stripe  {
        background-color:rgba(0,0,0,.05);
    }

    .edit-button {
        position: relative;
        top: -4px;
        opacity: 0;
    }

    .edit-button:hover {
        opacity: 1;
    }

    .btn-link {
        text-decoration: none;
    }

    .input-group {
        align-self: flex-start;
    }
</style>